const toSnakeCase = str =>
  str
    .split(/(?=[A-Z])/)
    .join('_')
    .toLowerCase();

export default toSnakeCase;
